<form [formGroup]="dashboardDaysForm" (ngSubmit)="saveOrExecuteAction()">
  <mat-form-field>
    <mat-label>Days</mat-label>
    <input formControlName="days" matInput type="number" min="1" required />
    @if (days.hasError('required')) {
      <mat-error> Days is <strong>required.</strong> </mat-error>
    }
    @if (days.hasError('min')) {
      <mat-error> Days should be more than zero. </mat-error>
    }
  </mat-form-field>
  <div class="m-0 empty-state mb-20!">
    <mat-icon>error_outline</mat-icon>
    <span>
      Jobs after this number of days will be hidden from your dashboard. They will remain available in the system
    </span>
  </div>
</form>
